import { SanityContentPage } from 'src/components/layouts/Page/SanityContentPage'

const BecomeAPlanterPage = () => {
  return <SanityContentPage slug='become-a-planter' />
}

export default BecomeAPlanterPage
